export const FULFILLMENT_STATUS_ALL = "Fulfillment Status (All)";
export const FULFILLMENT_STATUS_FULFILLED = "Fulfilled";
export const FULFILLMENT_STATUS_UNFULFILLED = "Unfulfilled";
export const FULFILLMENT_STATUS_REFUNDED = "Refunded";
export const FULFILLMENT_STATUS_UNCLAIMED = "Unclaimed";

export const SHIPPING_STATUS_ALL = "Shipment/Pickup (All)";
export const SHIPPING_STATUS_SHIP = "Shipping";
export const SHIPPING_STATUS_PICKUP = "Pickup";
